"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _Typography = _interopRequireDefault(require("@mui/material/Typography"));

var _DeleteButton = _interopRequireDefault(require("./DeleteButton"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Description = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Description, _Component);

  var _super = _createSuper(Description);

  function Description() {
    var _this;

    (0, _classCallCheck2["default"])(this, Description);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "goToProduct", function (e) {
      e.preventDefault();

      _this.props.changePage(_this.props.href);
    });
    return _this;
  }

  (0, _createClass2["default"])(Description, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          name = _this$props.name,
          number = _this$props.number,
          special = _this$props.special,
          label = _this$props.label,
          href = _this$props.href,
          coupon = _this$props.coupon,
          code = _this$props.code,
          removeItem = _this$props.removeItem,
          deletable = _this$props.deletable,
          coreCharge = _this$props.coreCharge;
      var specialDisplay = typeof special !== 'undefined' && typeof special.description !== 'undefined' && special.description != '' ? /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          color: 'red'
        }
      }, "Special Discount: ", special.description) : '';
      var couponDisplay = typeof coupon !== 'undefined' ? /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          color: 'green'
        }
      }, "Coupon: ", code) : '';
      var labelDisplay = label ? label : 'Part Number';
      var core = coreCharge ? coreCharge : 0;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        variant: "h6"
      }, /*#__PURE__*/_react["default"].createElement("a", {
        href: href,
        onClick: this.goToProduct
      }, name)), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          "float": 'left'
        }
      }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        variant: "body1"
      }, labelDisplay, ": ", /*#__PURE__*/_react["default"].createElement("b", null, number))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "hidden-lg hidden-md",
        style: {
          "float": 'right',
          marginRight: '-13px'
        }
      }, /*#__PURE__*/_react["default"].createElement(_DeleteButton["default"], {
        onClick: removeItem,
        deletable: deletable,
        style: {
          width: 'auto',
          height: 'auto',
          padding: '0 5px'
        }
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          clear: 'both'
        }
      }, specialDisplay, couponDisplay), /*#__PURE__*/_react["default"].createElement(CoreText, {
        charge: core
      }));
    }
  }]);
  return Description;
}(_react.Component);

exports["default"] = Description;

var CoreText = function CoreText(_ref) {
  var charge = _ref.charge;

  if (parseFloat(charge) <= 0) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      clear: 'both',
      color: 'green'
    }
  }, "Refundable $", charge, " Core Charge");
};